import Head from "next/head";
import { LoraShowcase } from "@/components/organisms/LoraLanding";
export default function LorasPage() {
  return <>
            {/* SEO Metadata */}
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>
                    Fantasy LORA Showcase | AI Models for D&D Images and Art
                </title>
                <meta name="description" content="Explore a collection of custom LORA models tailored for fantasy image generation, D&D characters, monsters, and immersive AI art. Perfect for RPG enthusiasts!" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:title" content="Fantasy LORA Showcase | Tailored AI Models for D&D Images" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:description" content="Discover custom LORA models for generating high-quality fantasy images, RPG scenes, D&D characters, and monsters. Fine-tuned AI art models for your needs." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:url" content="https://char-gen.com/loras" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:type" content="website" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta name="twitter:card" content="summary_large_image" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta name="twitter:title" content="LORA Showcase for Fantasy & D&D Image Generation" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta name="twitter:description" content="Explore AI fine-tuned LORA models designed for fantasy art, RPG characters, D&D monsters, and more." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <link rel="canonical" href="https://char-gen.com/loras" />
            </Head>

            {/* Page Content */}
            <div className="min-h-screen bg-background text-foreground p-4 md:p-8">
                <div className="max-w-7xl mx-auto">
                    <h1 className="text-4xl font-bold mb-6 text-gradient">
                        LORA Showcase for Fantasy Image Generation
                    </h1>
                    <p className="text-lg mb-8 text-muted-foreground">
                        Browse through a curated collection of Low-Rank
                        Adaptation (LORA) models optimized for generating
                        fantasy-themed images, including D&D characters,
                        monsters, and immersive RPG scenes. Start creating
                        unique AI art today.
                    </p>
                    <LoraShowcase data-sentry-element="LoraShowcase" data-sentry-source-file="index.tsx" />
                </div>
            </div>
        </>;
}